import { useTranslate } from "helpers";
import React, { useEffect, useState } from "react";

import { PageTitleProps } from "./types";

const PageTitle: React.FC<PageTitleProps> = ({ title, description, icon, iconColor }) => {
  const { t } = useTranslate();
  const [showTitle, setShowTitle] = useState(false);
  const [showDescription, setShowDescription] = useState(false);

  useEffect(() => {
    const titleTimer = setTimeout(() => setShowTitle(true), 100);
    const descTimer = setTimeout(() => setShowDescription(true), 300);

    return () => {
      clearTimeout(titleTimer);
      clearTimeout(descTimer);
    };
  }, []);

  return (
    <>
      <div className="py-2 overflow-hidden">
        <h1
          className={`transform transition-all duration-500 ease-out ${
            showTitle ? "translate-x-0 opacity-100" : "-translate-x-8 opacity-0"
          }`}
        >
          {t(title)}
        </h1>
        {description && (
          <p
            className={`text-slate-600 transform transition-all duration-500 ease-out ${
              showDescription ? "translate-x-0 opacity-100" : "-translate-x-8 opacity-0"
            }`}
          >
            {description}
          </p>
        )}
      </div>
    </>
  );
};

export default React.memo(PageTitle);
